"use strict";
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var _GeometryManager_geometryState, _GeometryManager_originalParentNode, _GeometryManager_parentNode, _GeometryManager_geometryManagerHelper;
Object.defineProperty(exports, "__esModule", { value: true });
exports.GeometryManager = void 0;
const GeometryManagerHelper_1 = require("./helpers/GeometryManagerHelper");
const GeometryState_1 = require("./GeometryState");
const viewer_shared_node_tree_1 = require("@shapediver/viewer.shared.node-tree");
class GeometryManager {
    // #endregion Properties (4)
    // #region Constructors (1)
    constructor(drawingToolsManager) {
        // #region Properties (4)
        _GeometryManager_geometryState.set(this, void 0);
        _GeometryManager_originalParentNode.set(this, void 0);
        _GeometryManager_parentNode.set(this, void 0);
        _GeometryManager_geometryManagerHelper.set(this, void 0);
        __classPrivateFieldSet(this, _GeometryManager_originalParentNode, drawingToolsManager.parentNode, "f");
        // create a new node with the geometry data
        const parentNode = new viewer_shared_node_tree_1.TreeNode('DrawingToolsGeometry');
        __classPrivateFieldGet(this, _GeometryManager_originalParentNode, "f").addChild(parentNode);
        __classPrivateFieldSet(this, _GeometryManager_parentNode, parentNode, "f");
        __classPrivateFieldSet(this, _GeometryManager_geometryState, new GeometryState_1.GeometryState(drawingToolsManager, this), "f");
        __classPrivateFieldSet(this, _GeometryManager_geometryManagerHelper, new GeometryManagerHelper_1.GeometryManagerHelper(drawingToolsManager, this, __classPrivateFieldGet(this, _GeometryManager_geometryState, "f")), "f");
        __classPrivateFieldGet(this, _GeometryManager_geometryState, "f").init();
    }
    // #endregion Constructors (1)
    // #region Public Getters And Setters (2)
    get geometryState() {
        return __classPrivateFieldGet(this, _GeometryManager_geometryState, "f");
    }
    get parentNode() {
        return __classPrivateFieldGet(this, _GeometryManager_parentNode, "f");
    }
    // #endregion Public Getters And Setters (2)
    // #region Public Methods (10)
    addPoint(index, position, temporary = false) {
        return __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").addPoint(index, position, temporary);
    }
    canAddPoint() {
        return __classPrivateFieldGet(this, _GeometryManager_geometryState, "f").canAddPoint();
    }
    canRemovePoint() {
        return __classPrivateFieldGet(this, _GeometryManager_geometryState, "f").canRemovePoint();
    }
    close() {
        __classPrivateFieldGet(this, _GeometryManager_geometryState, "f").close();
        __classPrivateFieldGet(this, _GeometryManager_originalParentNode, "f").removeChild(__classPrivateFieldGet(this, _GeometryManager_parentNode, "f"));
        __classPrivateFieldGet(this, _GeometryManager_originalParentNode, "f").updateVersion();
    }
    createLineIndices(loop) {
        __classPrivateFieldGet(this, _GeometryManager_geometryState, "f").createLineIndices(loop);
    }
    movePoint(index, position, temporary = false) {
        __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").movePoint(index, position, temporary);
    }
    removePoint(removalIndex, temporary = false) {
        return __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").removePoint(removalIndex, temporary);
    }
    removePoints(removalIndices) {
        __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").removePoints(removalIndices);
    }
    resetMaterialIndices() {
        __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").resetMaterialIndices();
    }
    updateMaterialIndex(index, materialIndex) {
        __classPrivateFieldGet(this, _GeometryManager_geometryManagerHelper, "f").updateMaterialIndex(index, materialIndex);
    }
}
exports.GeometryManager = GeometryManager;
_GeometryManager_geometryState = new WeakMap(), _GeometryManager_originalParentNode = new WeakMap(), _GeometryManager_parentNode = new WeakMap(), _GeometryManager_geometryManagerHelper = new WeakMap();
//# sourceMappingURL=GeometryManager.js.map